import React, { FC } from "react";
import { OptimizelyFullImageBlock } from "../../types/optimizely/blocks";
import { FullImageBlock } from "../FullImageBlock/FullImageBlock";
import { getButtonVariant } from "../../utils/getButtonVariant";
import Link from "../Link/Link";
export interface FullImageBlockWrapperProps {
  module: OptimizelyFullImageBlock;
}

const FullImageBlockWrapper: FC<FullImageBlockWrapperProps> = ({
  module,
}) => {
  const headerButton = module.headerCallToActionButtons?.expandedValue?.[0];
  const hasHeaderButton = module.headerCallToActionButtons?.expandedValue?.length > 0;

  const headerWords = module.headerText?.value?.split(' ') || [];
  
  const firstWord = headerWords[0];
  const remainingWords = headerWords.slice(1).join(' ');

  return (
    <div id={module.sectionId?.value ?? ''}>
      <div className="flex flex-row justify-between items-end bg-white">
        <h2 className="text-3xl text-primary ml-8 md:ml-[62px] mt-[41px]">
          <span>{firstWord}</span> <span className="font-bold">{remainingWords}</span>
        </h2>
        {hasHeaderButton && (
          <Link
            text={headerButton.linkText.value}
            href={headerButton.buttonLink?.value}
            variant={getButtonVariant(headerButton.buttonType?.value)}
            className="min-h-10 mr-8 md:mr-[62px] hidden md:flex h-fit"
          />
        )}
      </div>
      <div className={module.imageMobile?.expandedValue?.url ? "hidden md:block" : "block"}>
        <FullImageBlock
          backgroundImage={module.image?.expandedValue?.url}
          backgroundColor={module.backgroundColor?.value}
          subTitle={module.subTitle?.value}
          title={module.title?.value}
          fontColor={module.fontColor?.value}
          fullHeight={module.fullHeight?.value}
          imageCaption={module.imageCaption?.value}
          actions={module.callToActionButtons?.expandedValue?.map((cta, idx) => (
            <Link
              key={idx}
              text={cta.linkText.value}
              href={cta.buttonLink?.value}
              variant={getButtonVariant(cta.buttonType?.value)}
              className="min-h-10"
            />
          ))}
        />
      </div>
      <div className={module.imageMobile?.expandedValue?.url ? "block md:hidden" : "hidden"}>
        <FullImageBlock
          backgroundImage={module.imageMobile?.expandedValue?.url}
          backgroundColor={module.backgroundColor?.value}
          subTitle={module.subTitle?.value}
          title={module.title?.value}
          fontColor={module.fontColor?.value}
          fullHeight={module.fullHeight?.value}
          imageCaption={module.imageCaption?.value}
          actions={module.callToActionButtons?.expandedValue?.map((cta, idx) => (
            <Link
              key={idx}
              text={cta.linkText.value}
              href={cta.buttonLink?.value}
              variant={getButtonVariant(cta.buttonType?.value)}
              className="min-h-10"
            />
          ))}
        />
      </div>
      {hasHeaderButton && (
        <div className="bg-white py-6 container">
          <Link
            text={headerButton.linkText.value}
            href={headerButton.buttonLink?.value}
            variant={getButtonVariant(headerButton.buttonType?.value)}
            className="min-h-10 w-max md:hidden flex"
          />
        </div>
      )}
    </div>
  );
};

export default FullImageBlockWrapper;
